
jQuery(document).ready(function(){
// 						alert(1);		
	var initObj		= new initEnv();
	
	initObj.init();
  
//   	custom js here
  
  $(".upsell-popup-wrap .close-popup").click(function(){
  	$(".upsell-popup-wrap").removeClass("show");
  
  });
    $(".aglet-cart-to-cart").click(function(){
      	
      var agletid = $(this).attr("id");
      	
      	 $.ajax(
         {
           type: "POST", dataType: "json", data: {
            id: agletid , quantity: 1 
           } ,
            url: "/cart/add.js",
            success: function (data) {
                cutomaddToCart(productdata);
            },error : function(data){
            alert("error");
            }
          });
      
	
    });
  	$(".skip").click(function(){
		cutomaddToCart(productdata);	
    });
  
  
});

function cutomaddToCart(productdata) {
         $.ajax(
         {
            type: "POST", dataType: "json", data: productdata ,
            url: "/cart/add.js",
            success: function (data) {
                document.location.href="/cart";
            },error : function(data){
            alert("error");
            }
          });
}

function dataURLtoBlob(dataURL) {
// Decode the dataURL    
var binary = atob(dataURL.split(',')[1]);
// Create 8-bit unsigned array
var array = [];
for(var i = 0; i < binary.length; i++) {
    array.push(binary.charCodeAt(i));
 }
// Return our Blob object
return new Blob([new Uint8Array(array)], {type: 'image/png'});
 }

var projectID  		= "";
var select_group 	= undefined;

var initEnv			= function()
{
	var main		= this;

	main.data 	= [];
	main.obj_3d 	= null;

	main.text_m 	= "left";
	main.text_l  	= "Left Panel";
	main.text_r 	= "Right Panel";

	main.font_l 	= 0;
	main.font_r 	= 0;
	main.mode 		= "engraved"; // painted
	main.fill 		= "fill";

	main.init		= function()
	{
		main.initCSS();
		main.init3D();
		main.initColor();
		main.initFont();
		main.initEvent();
		main.initMode();

		window.addEventListener( 'resize', main.initCSS );
	}

	main.initCSS 	= function()
	{
		if($(window).height() > $(window).width())
		{
			$("body").addClass("mobile");
		}
		else
		{
			$("body").removeClass("mobile");
		}
	}

	main.initMode 	= function()
	{
		$("#image_area").css("display", "none");
		$("#color_list").css("display", "none");
		$("#title-area dl").css("width", "157px");

		$("#title-area").find("dd:nth-child(3)").css("display", "none");
		$("#title-area").find("dd:nth-child(4)").css("display", "none");
	}

	main.init3D 	= function()
	{
		var width 	= $("#render_area").width();
		var height 	= $("#render_area").height();
		console.log($.fn.jquery)
		main.obj_3d = jQuery("#render_area").showModel({width : width, height : height});
	}

	main.initEvent 	= function()
	{
		$("#btn_back").click(function()
		{
			$("#right_menu").fadeOut();
			$("#btn_back").fadeOut();
		});

		$("#tool-area li").click(function(evt)
		{
			var index = $(this).index();

			$("#sub-menu .active").removeClass("active");
			
			$("#right_menu").fadeIn();

			if($("body").hasClass("mobile"))
				$("#btn_back").fadeIn();

			$("#right_menu .sel").removeClass("sel");

			if($(this).attr("id") != "btn_buy")
			{
				$("#tool-area").find(".active").removeClass("active");
				$(this).addClass("active");
			}

			if(main.mode == "painted")
			{
				$("#image_area").css("display", "block");
				$("#color_list").css("display", "block");
			}
			else
			{
				$("#image_area").css("display", "none");
				$("#color_list").css("display", "none");
			}

			switch(index)
			{
				case 0 : 
					$("#size_menu").addClass("sel");
					$("#right_menu h2").html("SIZE AREA");
				break;

				case 1 :
					$("#color_menu").addClass("sel");
					$("#right_menu h2").html("BASE COLOR");
				break;

				case 2 :
					main.text_m = "left";

					$("#text_area").addClass("sel");
					$("#image_area").addClass("sel");
					
					$("#txt_panel").val("");
					$("#txt_panel").focus();

					$("#text_menu") .addClass("sel");
					$("#sub_design").addClass("active");
					$("#font_menu").addClass("sel");
					$("#right_menu h2").html("LEFT DESIGN");
				break;
				case 3 :
					main.text_m = "right";

					$("#text_area").addClass("sel");
					$("#image_area").addClass("sel");
					
					$("#txt_panel").val("");
					$("#txt_panel").focus();

					$("#text_menu") .addClass("sel");
					$("#sub_design").addClass("active");
					$("#font_menu").addClass("sel");
					$("#right_menu h2").html("RIGHT DESIGN");
				break;
				case 4 :
					var size 	= $("#title-area dd:nth-child(1)").html();
					var pcolor 	= $("#title-area dd:nth-child(2)").html();

					console.log(size, pcolor);
					console.log("left:", main.text_l, main.font_list[main.font_l].title);
					console.log("right:", main.text_r, main.font_list[main.font_r].title);
				break;
			}

			evt.stopPropagation();
		});

		$("#mobile_button").click(function(evt)
		{
			$("#right_menu").fadeIn();
			evt.stopPropagation();
		});

		$("#right_menu").click(function(evt)
		{
			evt.stopPropagation();
		});

		$("#size_menu dd").click(function()
		{
			var index = $(this).index();
			var scale = 1;
			// no return
       return;
			$("#title-area dd:nth-child(1)").html("1.5 INCH");

			if(index == 0)
			{
				scale = 0.85;

				$("#title-area dd:nth-child(1)").html("1.25 INCH");
			}

			main.obj_3d.updateSize(scale);
		});

		$(".section h3").click(function()
		{
			if($(this).parent().hasClass("show"))
			{
				$(this).parent().removeClass("show");
				$(this).parent().addClass("hide");
			}
			else
			{
				$(this).parent().addClass("show");
				$(this).parent().removeClass("hide");
			}

			// $(this).parent().children(".sub_content").toggle();
		});

		$("#btn_personalize").click(function()
		{
			$("#tool-area").addClass("expanded");

			$("#btn_design_left").css("display", "block");
			$("#btn_design_right").css("display", "block");
		});

		
      $('#btn_addtocart').click(function(){
      
        var size 	= $("#title-area dd:nth-child(1)").html();
					var pcolor 	= $("#title-area dd:nth-child(2)").html();

					console.log(size, pcolor);
					console.log("left:", main.text_l, main.font_list[main.font_l].title);
					console.log("right:", main.text_r, main.font_list[main.font_r].title);
                	productdata =  {
            id: 7335332315187 , quantity: 1 ,
              properties: {
                'Size': size ,
                'Color' : pcolor ,
                'Left Text' : main.text_l,
                'Left Font' : main.font_list[main.font_l].title,
                'Right Text' : main.text_r,
                'Right Font' : main.font_list[main.font_r].title,
                
                           }
                };
                var type = "Engraved";
                if( main.text_l == "Left Panel" && main.font_list[main.font_l].title == "Arial" && main.text_r == "Right Panel" && main.font_list[main.font_r].title == "Arial" ) {
                	type = "Non-Engraved";
                }
                
                $(".varient-info").each(function(index, value ){
                 var currenttype = $(this).attr("data-option1");
                 var currentcolor = $(this).attr("data-option2").toUpperCase();
                  if((pcolor.includes(currentcolor)) && ( type == currenttype )){
                    
                  productdata.id = parseInt($(this).attr("data-id")) ;
                   return false;
                  
                  }
                
                });
                
                var currentpcolor = pcolor.toLowerCase().replace("base","").trim();
                var productmatch = false;   
                $(".upsell-products.show").removeClass("show");
                $(".upsell-products").each(function(index, value){
                   var aglettitle = $(this).attr("data-title").toLowerCase();
                  if(aglettitle.includes(currentpcolor)) {
					$(this).addClass("show");
                 $(".upsell-popup-wrap").addClass("show");
                    productmatch = true;
                    return false;

                  }
                });
                if(!productmatch){
                cutomaddToCart(productdata);
                }
      
      });
      
      $("#btn_go_back").click(function(){
      location = "https://panelcustomizer.myshopify.com/collections/all";
      });	



		$("#txt_panel").on("keyup", function()
		{
			var text = $(this).val();
			var font = $("#font_list").val();

			if(main.text_m == "left")
				main.text_l = text;
			else
				main.text_r = text;

			main.obj_3d.updateText(main.text_m, text, font, main.mode, main.fill);
		});

		$("#btn_mode").click(function()
		{
			return;
			$("#drop_mode").css("display", "block");
		});

		$(".sub_menu h5").click(function(evt)
		{
			$(this).parent().children("dl").fadeIn();
			evt.stopPropagation();
		});

		$("#drop_mode li").click(function()
		{
			$("#drop_mode .active").removeClass("active");
			$(this).addClass("active");

			$("#btn_mode").html($(this).html());
			$("#drop_mode").css("display", "none");

			main.mode = "painted";

			if($(this).index() == 1)
				main.mode = "engraved";

			if(main.mode == "painted")
			{
				$("#image_area").css("display", "block");
				$("#color_list").css("display", "block");
				$("#title-area dl").css("width", "100%");

				$("#title-area").find("dd:nth-child(3)").css("display", "block");
				$("#title-area").find("dd:nth-child(4)").css("display", "block");
			}
			else
			{
				$("#image_area").css("display", "none");
				$("#color_list").css("display", "none");
				$("#title-area dl").css("width", "157px");

				$("#title-area").find("dd:nth-child(3)").css("display", "none");
				$("#title-area").find("dd:nth-child(4)").css("display", "none");
			}

			var text = $("#txt_panel").val();
			var font = $("#font_list").val();

			main.obj_3d.updateText("left", main.text_l, main.font_list[main.font_l].value, main.mode);
			main.obj_3d.updateText("right", main.text_r, main.font_list[main.font_r].value, main.mode);
		});

		$(document).on("click", function()
		{
			$(".sub_menu dl").css("display", "none");
		});
	}

	main.initColor 	= function()
	{
		var color_list = [
			{
				"title" : "Gold",
				"value" : "0xf4c712"
			},
			{
				"title" : "Silver",
				"value" : "0xb2b2b2"
			},
			{
				"title" : "Rose Gold",
				"value" : "0xb47158"
			},
			{
				"title" : "Gun Metal",
				"value" : "0x312a26"
			},
			{
				"title" : "Yellow Gold",
				"value" : "0xd79e06"
			},
			{
				"title" : "Matte Black",
				"value" : "0x353533"
			},
			{
				"title" : "Black",
				"value" : "0x111111"
			},
			{
				"title" : "White",
				"value" : "0xffffff"
			},
			{
				"title" : "Red",
				"value" : "0xe40a1b"
			},
			{
				"title" : "Blue",
				"value" : "0x214cd6"
			},
			{
				"title" : "Dark Blue",
				"value" : "0x1a36b3"
			},
			{
				"title" : "Baby Blue",
				"value" : "0x96c1e4"
			},
			{
				"title" : "South Beach Blue",
				"value" : "0x49d2e2"
			},
			{
				"title" : "Grape",
				"value" : "0x4e2068"
			},
			{
				"title" : "Perfect Pink",
				"value" : "0xf5649b"
			},
			{
				"title" : "South Beach Pink",
				"value" : "0xda244c"
			},
			{
				"title" : "Hyper Pink",
				"value" : "0xfe016e"
			},
			{
				"title" : "Mint",
				"value" : "0x89e0cd"
			},
			{
				"title" : "Horizon Blue",
				"value" : "0x2e5aa1"
			},
			{
				"title" : "Azure Blue",
				"value" : "0x387bc2"
			},
			{
				"title" : "Cream",
				"value" : "0xecdf77"
			},
			{
				"title" : "Volt",
				"value" : "0xccee01"
			}, 
			{
				"title" : "Neon Green",
				"value" : "0x4ef54d"
			}, 
			{
				"title" : "Green",
				"value" : "0x54ab4e"
			},
			{
				"title" : "Orange",
				"value" : "0xe83314"
			},
			{
				"title" : "Highlighter",
				"value" : "0xd8e500"
			},
			{
				"title" : "Navy",
				"value" : "0x11172d"
			},
			{
				"title" : "Army Green",
				"value" : "0x3f491f"
			},
			{
				"title" : "Leaf Green",
				"value" : "0x66d711"
			},
			{
				"title" : "Gray",
				"value" : "0xc1c1c1"
			},
			{
				"title" : "Light Gray",
				"value" : "0xeee6db"
			},
			{
				"title" : "Pastel Yellow",
				"value" : "0xe3db42"
			},
			{
				"title" : "Lime",
				"value" : "0xbed606"
			},
			{
				"title" : "White / Black Speckle",
				"value" : "0xbdd407",
				"pattern" : "white_to_black"
			},
			{
				"title" : "Black / White Speckle",
				"value" : "0xbdd407",
				"pattern" : "black_to_white"
			},
			{
				"title" : "Gray / Gray Speckle",
				"value" : "0xbdd407",
				"pattern" : "gray_to_black"
			},
			{
				"title" : "Metallic Gold",
				"value" : "0xbdd407",
				"pattern" : "golden"
			},
			{
				"title" : "Metallic Silver",
				"value" : "0xbdd407",
				"pattern" : "silver"
			},
			{
				"title" : "Copper",
				"value" : "0xbdd407",
				"pattern" : "copper"
			},
			{
				"title" : "Industrial Copper",
				"value" : "0xbdd407",
				"pattern" : "industrial_copper"
			},
			{
				"title" : "Antique Gold",
				"value" : "0xbdd407",
				"pattern" : "golden_antique"
			},
			{
				"title" : "Gold Iridescent",
				"value" : "0xbdd407",
				"pattern" : "golden_iridesent"
			},
			{
				"title" : "Gold Graident",
				"value" : "0xbdd407",
				"pattern" : "golden_gradient"
			},
			{
				"title" : "Iridesent",
				"value" : "0xbdd407",
				"pattern" : "iridesent"
			},
			{
				"title" : "Gradient",
				"value" : "0xbdd407",
				"pattern" : "gradient"
			},
			{
				"title" : "Volt / Hyper Pink Fusion",
				"value" : "0xbdd407",
				"pattern" : "volt"
			},
			{
				"title" : "Silver Iridescent",
				"value" : "0xbdd407",
				"pattern" : "silver_iridesent"
			},
		];

		var font_color = [
			{
				"title" : "Gold",
				"value" : "0xf4c712"
			},
			{
				"title" : "Silver",
				"value" : "0xb2b2b2"
			},
			{
				"title" : "Black",
				"value" : "0x1f1f1f"
			},
			{
				"title" : "Red",
				"value" : "0xe31125"
			},
			{
				"title" : "Blue",
				"value" : "0x142ce2"
			}
		];

		$("#color_menu dl").html("");
		$("#color_list dl").html("");

		for(var i = 0; i < color_list.length; i ++)
		{
			if(color_list[i].pattern)
			{
				$("#color_menu dl").append("<dd pattern=" + color_list[i].pattern + "><p>&nbsp;</p><span>" + color_list[i].title + "</span></dd>");
				$("#color_menu dd:last-child p").css("background-image", "url(http://venus.ourgoogle.in/shopify/sandeep/panelcustomiizer/source_v15/model/texture/" + color_list[i].pattern + "/DefaultMaterial_Base_Color.png)");
			}
			else
			{
				$("#color_menu dl").append("<dd color=" + color_list[i].value + "><p>&nbsp;</p><span>" + color_list[i].title + "</span></dd>");
				$("#color_menu dd:last-child p").css("background-color", color_list[i].value.replace("0x", "#"));
			}
		}

		for(var i = 0; i < font_color.length; i ++)
		{
			$("#color_list dl").append("<dd color=" + font_color[i].value + " value='" + font_color[i].title + "'></dd>");
			$("#color_list dd:last-child").css("background-color", font_color[i].value.replace("0x", "#"));
		}

		$("#color_list dl").append('<dd class="button" id="btn_color"><img src="img/icon_palete_color.png"></dd>');

		$("#color_menu dd").click(function()
		{
			var color   = $(this).attr("color");
			var pattern = $(this).attr("pattern");

			main.obj_3d.updatePanelColor(color, pattern, main.fill);

			$("#title-area dd:nth-child(2)").html($(this).children("span").html().toUpperCase() + " BASE");
		});

		$("#engrave_mode").on("change", function()
		{
			var font = main.font_list[main.font_l].value;

			main.fill = $(this).val();
			main.obj_3d.updateText("left", main.text_l, font, main.mode, main.fill);
			main.obj_3d.updateText("right", main.text_r, font, main.mode, main.fill);
		});

		$("#color_list dd").click(function()
		{
			var color = $(this).attr("color");

			main.obj_3d.updateTextColor(main.text_m, color);

			if(main.text_m == "left")
			{
				$("#title-area dd:nth-child(4)").html($(this).attr("value").toUpperCase() + " LEFT");
			}
			else
			{
				$("#title-area dd:nth-child(3)").html($(this).attr("value").toUpperCase() + " RIGHT");
			}

			$("#color_list h5").html($(this).attr("value") + "<span>&nbsp</span>");
			$("#color_list h5 span").css('background', color.replace("0x", "#"));
		});
	}

	main.initFont 	= function()
	{
		main.font_list = [
			{
				"title" : "Arial",
				"value" : "arial.ttf",
			},
			{
				"title" : "ExcaliburMonospace",
				"value" : "ExcaliburMonospace.ttf"
			},
			{
				"title" : "OleoScript",
				"value" : "OleoScript-Regular.ttf"
			}
		];

		$("#font_list").html("");

		for(var i = 0; i < main.font_list.length; i ++)
		{
			if(i == 0)
				$("#font_list").append("<option value=" + main.font_list[i].value + ">" + main.font_list[i].title + "</dd>");
			else
				$("#font_list").append("<option value=" + main.font_list[i].value + ">" + main.font_list[i].title + "</dd>");
		}

		$("#font_list").on("change", function()
		{
			var text = $("#txt_panel").val();
			var font = $("#font_list").val();

			main.font_l = $(this).index();
			main.font_r = $(this).index();

			main.obj_3d.updateText("left", main.text_l, font, main.mode, main.fill);
			main.obj_3d.updateText("right", main.text_r, font, main.mode, main.fill);
		});
	}
}